<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Generate PDF</strong>
                    </div>
                    <b-row>
                        <b-col sm="12">
                            <b-form-group>
                                <label>Countries</label>
                                <b-form-select v-model="country_id" :options="countries" class="mb-3" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12">
                            <b-button type="submit" size="lg" variant="primary" @click="printPDF">Generate PDF</b-button>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import axios from 'axios'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
    "ukai": {
        normal: 'ukai.ttf',
        bold: 'ukai.ttf',
        italics: 'ukai.ttf',
        bolditalics: 'ukai.ttf'
    },
    "Garuda": {
        normal: 'Garuda.ttf',
        bold: 'Garuda.ttf',
        italics: 'Garuda.ttf',
        bolditalics: 'Garuda.ttf'
    },
    "Hanumanb": {
        normal: 'Hanumanb.ttf',
        bold: 'Hanumanb.ttf',
        italics: 'Hanumanb.ttf',
        bolditalics: 'Hanumanb.ttf'
    },
};
export default{
    data(){
        return{
            font:'ukai',
            country_id:'OTH',
            countries:['TH','KH','OTH']
        }
    },
    methods:{
        printPDF(){

            if(this.country_id == 'TH')
            {
                this.font = 'Garuda'
            }
            else if(this.country_id == 'KH')
            {
                this.font = 'Hanumanb'
            }
            else
            {
                this.font = 'ukai'
            }
            var date = new Date()
            var dd = {
                  header:{ text: 'Test PDF'+ " "+ date, margin: [ 5, 10, 10, 30 ],alignment: 'center',fontSize:9 },
                  pageSize: 'A4',
                  pageOrientation: 'portrait',
                  defaultStyle: {
                    font: this.font
                  },
                  pageMargins: [30, 30, 30, 20 ],
                  content: [
                    {
                      fontSize: 9.5,
                      font:'ukai',
                      text: 'English - Using English Font',
                    },
                    {
                      fontSize: 9.5,
                      font:'ukai',
                      text: 'Chinese - 漢語 (文章)段 (文章的)段 小新闻 段 段落 短文 短评 节',
                    },
                    {
                      fontSize: 9.5,
                      font:'Garuda',
                      text: 'Thailand -14000101534 - พระอุดมศักดิ์ ทรัพย์สัณฐิติกุล',
                    },
                    {
                      fontSize: 9.5,
                      font:'Hanumanb',
                      text: 'Cambodia -  ហ្វ៊ីលនិគ្គហិត',
                    },
                  ]
                };
                pdfMake.createPdf(dd).open();
        }
    }
}

</script>


// WEBPACK FOOTER //
// src/views/test/pdfTest.vue